import React, { Component } from "react";

/**
 * @desc recruiter comments candidate profile section
 * @param props
 * @return DOMElement
 */
const RecruiterComments = props => {
  return (
    <div className="recruiter-comments tab-body">
      <li>{props.text}</li>
    </div>
  );
};

export default RecruiterComments;



// WEBPACK FOOTER //
// ./src/components/Client/RecruiterComments/RecruiterComments.js